export const productOptions = {
  buttonDestination: 'modal',
  variantId: 'all',
  isButton: true,
  contents: {
    imgWithCarousel: false,
    variantTitle: false,
    options: false,
    description: false,
    buttonWithQuantity: false,
    button: false,
    quantity: false,
  },
  text: {
    button: 'View >',
  },
  styles: {
    product: {
      '@media (min-width: 601px)': {
        'max-width': 'calc(25% - 20px)',
        'margin-left': '20px',
        'margin-bottom': '50px',
        width: 'calc(25% - 20px)',
      },
      'min-width': '0px',
      'max-width': '100%',
      'margin-top': '5px',
      imgWrapper: {
        position: 'relative',
        height: '0',
        'padding-top': 'calc(70% + 15px)',
      },
      img: {
        height: 'calc(100% - 4px)',
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
      },
      title: {
        'margin-bottom': '0px',
      },
    },
    button: {
      'background-color': '#555a92',
      'font-size': '13px',
      'padding-top': '14.5px',
      'padding-bottom': '14.5px',
      ':hover': {
        'background-color': '#4d5183',
      },
      ':focus': {
        'background-color': '#4d5183',
      },
    },
    title: {
      'font-size': '13px',
    },
    quantityInput: {
      'font-size': '13px',
      'padding-top': '14.5px',
      'padding-bottom': '14.5px',
    },
  },
}

export const cartOptions = {
  contents: {
    button: true,
  },
  styles: {
    button: {
      'background-color': '#555a92',
      'font-size': '13px',
      'padding-top': '14.5px',
      'padding-bottom': '14.5px',
      ':hover': {
        'background-color': '#4d5183',
      },
      ':focus': {
        'background-color': '#4d5183',
      },
    },
    footer: {
      'background-color': '#ffffff',
    },
  },
}

export const modalProductOptions = {
  contents: {
    img: false,
    imgWithCarousel: true,
    variantTitle: false,
    buttonWithQuantity: true,
    button: false,
    quantity: false,
  },
  styles: {
    product: {
      '@media (min-width: 601px)': {
        'max-width': '100%',
        'margin-left': '0px',
        'margin-bottom': '0px',
      },
    },
    button: {
      'background-color': '#555a92',
      'font-size': '13px',
      'padding-top': '14.5px',
      'padding-bottom': '14.5px',
      ':hover': {
        'background-color': '#4d5183',
      },
      ':focus': {
        'background-color': '#4d5183',
      },
    },
    quantityInput: {
      'font-size': '13px',
      'padding-top': '14.5px',
      'padding-bottom': '14.5px',
    },
  },
}

export const toggleOptions = {
  styles: {
    toggle: {
      'background-color': '#555a92',
      ':hover': {
        'background-color': '#4d5183',
      },
      ':focus': {
        'background-color': '#4d5183',
      },
    },
    count: {
      'font-size': '13px',
    },
  },
}

export const productSetOptions = {
  styles: {
    products: {
      '@media (min-width: 601px)': {
        'margin-left': '-20px',
      },
    },
  },
}
